import { Component } from "react"
import PropTypes from "prop-types"
import { isEmpty, map } from "lodash"
import Card from "components/card"
import InlineSelector from "components/inline-selector"
import "./style.scss"
import { Autocomplete, TextField } from "@mui/material"

const WEEKLY_OPTIONS = [
  { value: "never", display: "Off" },
  { value: "weekly", display: "On" },
]

function Option({ label }) {
  return <div className="option-container">
    <div className="option-portfolio">{label}</div>
  </div>
}

Option.propTypes = {
  label: PropTypes.string.isRequired,
}

class EmailSubscriptions extends Component {
  onChangePortfolios = (_, selected) => {
    // if selected is null (no selection, return empty array)
    this.onChange(selected || [])
  }

  onChangeFactorImpact = value => {
    let { emails } = this.props
    emails = { ...emails, factorimpact: { frequency: value } }

    this.onChange(null, emails)
  }

  onChange = (portfolios, emails) => {
    const { update, updateUrl } = this.props

    if (!emails) {
      emails = this.props.emails
    }

    if (!portfolios) {
      portfolios = this.props.selectedPortfolios
    }

    const portfolioIds = map(portfolios, p => p.value)

    update("subscriptions", updateUrl, {
      portfolioIds,
      emails,
    }, {
      onSuccess: "Subscriptions updated",
      onError: "An unknown error happened when trying to update your subscriptions. Please try again later.",
    })
  }

  render() {
    const { availablePortfolios, selectedPortfolios, emails } = this.props
    return <Card title="Email Subscriptions" className="modules_email-subscriptions">
      <div className="subscriptions-content">
        <div className="portfolios">
          <div className="MultiSelectInput form-group">
            <Autocomplete
              value={selectedPortfolios}
              onChange={this.onChangePortfolios}
              multiple
              options={availablePortfolios}
              getOptionLabel={(option) => option.label}
              isOptionEqualToValue={(option, value) => option.value === value.value}
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="standard"
                  label={<label>Select portfolio(s)<span className="text-muted"> to include in each email digest</span></label>}
                  placeholder={isEmpty(selectedPortfolios) ? "Select..." : null}
                />
              )}
            />
          </div>
        </div>
        <div className="emails form-group">
          <label>Select email(s)</label>
          <ul className="list-group">
            <li className="list-group-item">
              <div className="d-flex w-100 justify-content-between mb-2">
                <h5 className="font-weight-bold">Factor Impact Summary</h5>
                <InlineSelector options={WEEKLY_OPTIONS} selectedValue={emails.factorimpact.frequency} onSelect={this.onChangeFactorImpact} />
              </div>
              <p className="mb-1">Report containing a breakdown of your factor and idiosyncratic risk along with the factors driving the performance and risk of your portfolio.</p>
            </li>
          </ul>
        </div>
      </div>
    </Card>
  }
}

EmailSubscriptions.propTypes = {
  availablePortfolios: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    className: PropTypes.string,
  })).isRequired,
  selectedPortfolios: PropTypes.arrayOf(PropTypes.object).isRequired,
  emails: PropTypes.shape({
    factorimpact: PropTypes.shape({ frequency: PropTypes.string.isRequired }).isRequired,
  }).isRequired,
  update: PropTypes.func.isRequired,
  updateUrl: PropTypes.string.isRequired,
}

export default EmailSubscriptions
